import { Button, Popconfirm, Table } from 'antd';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { OhatScore } from '@models/ohatScore';
import { format } from '../../utils/date';
import { useNavigate } from 'react-router-dom';
import { CameraOutlined, DeleteOutlined } from '@ant-design/icons';

export type Props = {
  scores: OhatScore[];
  onDelete: (id: string) => {};
};
export const OhatScoresTable = (props: Props) => {
  const { scores, onDelete } = props;
  const navigate = useNavigate();
  const { t } = useTranslation();

  const onConfirm = async (id: string) => {
    await onDelete(id);
  };

  const scoreData = useMemo(() => {
    return scores.map((v) => {
      return {
        key: v.id,
        date: format(v.evaluatedAt, 'MM/DD HH:mm'),
        dateRaw: v.evaluatedAt,
        score: v.q1 + v.q2 + v.q3 + v.q4 + v.q5 + v.q6 + v.q7 + v.q8,
        photoCount: v.photoCount ?? 0,
      };
    });
  }, [scores]);

  const columns = [
    {
      title: t('scoresTable.dateTime'),
      dataIndex: 'date',
      key: 'date',
      // defaultSortOrder: 'descend' as SortOrder,
      // sorter: (a: any, b: any) => a.localeCompare(b),
    },
    {
      title: t('scoresTable.score'),
      dataIndex: 'score',
      key: 'score',
    },
    {
      title: t('scoresTable.photos'),
      dataIndex: 'photoCount',
      key: 'photoCount',
      render: (photoCount: number) =>
        photoCount > 0 ? (
          <span style={{ whiteSpace: 'nowrap' }}>
            <CameraOutlined style={{ marginRight: 4 }} />
            {photoCount}
          </span>
        ) : null,
    },
    {
      title: '',
      render: (_: any, record: any) => (
        <span
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
          }}
        >
          <Button
            type="default"
            size="large"
            onClick={() => navigate(`ohat-scores/${record.key}`)}
            style={{ marginRight: 20 }}
          >
            {t('scoresTable.view')}
          </Button>
          <Popconfirm
            title={t('common.deleteConfirm')}
            okText="Yes"
            cancelText="No"
            onConfirm={() => onConfirm(record.key)}
          >
            <Button danger shape="circle" icon={<DeleteOutlined />} />
          </Popconfirm>
        </span>
      ),
      key: 'action',
    },
  ];

  return (
    <Table
      dataSource={scoreData}
      columns={columns}
      pagination={{
        pageSize: 5,
      }}
    />
  );
};
